import { IconV2 } from 'components/common/IconV2/IconV2';
import type { SmallIconV2Props } from 'components/common/IconV2/IconV2.types';

const InfoFilledSmallIcon = (props: SmallIconV2Props) => (
  <IconV2 {...props} viewBox="0 0 16 16">
    <mask id="icon__path-1-inside-1_11923_1803" fill="#fff">
      <path
        fillRule="evenodd"
        d="M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0M8.7 5.7a.7.7 0 1 1-1.4 0 .7.7 0 0 1 1.4 0M8.6 8a.6.6 0 0 0-1.2 0v3.25a.6.6 0 1 0 1.2 0z"
        clipRule="evenodd"
      />
    </mask>
    <path
      fill="currentcolor"
      fillRule="evenodd"
      d="M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0M8.7 5.7a.7.7 0 1 1-1.4 0 .7.7 0 0 1 1.4 0M8.6 8a.6.6 0 0 0-1.2 0v3.25a.6.6 0 1 0 1.2 0z"
      clipRule="evenodd"
    />
    <path
      fill="currentcolor"
      d="M8 16a8 8 0 0 0 8-8h-2a6 6 0 0 1-6 6zM0 8a8 8 0 0 0 8 8v-2a6 6 0 0 1-6-6zm8-8a8 8 0 0 0-8 8h2a6 6 0 0 1 6-6zm8 8a8 8 0 0 0-8-8v2a6 6 0 0 1 6 6zm-8-.6a1.7 1.7 0 0 0 1.7-1.7h-2a.3.3 0 0 1 .3-.3zM6.3 5.7A1.7 1.7 0 0 0 8 7.4v-2a.3.3 0 0 1 .3.3zM8 4a1.7 1.7 0 0 0-1.7 1.7h2A.3.3 0 0 1 8 6zm1.7 1.7A1.7 1.7 0 0 0 8 4v2a.3.3 0 0 1-.3-.3zM8 8.4a.4.4 0 0 1-.4-.4h2A1.6 1.6 0 0 0 8 6.4zm.4-.4a.4.4 0 0 1-.4.4v-2A1.6 1.6 0 0 0 6.4 8zm0 3.25V8h-2v3.25zm-.4-.4c.22 0 .4.18.4.4h-2a1.6 1.6 0 0 0 1.6 1.6zm-.4.4c0-.22.18-.4.4-.4v2a1.6 1.6 0 0 0 1.6-1.6zM7.6 8v3.25h2V8z"
      mask="url(#icon__path-1-inside-1_11923_1803)"
    />
  </IconV2>
);

export default InfoFilledSmallIcon;
